import { useTranslation } from "react-i18next";

export const useIsParlayLocale = (): boolean =>
  useTranslation().t("Multi") !== "Multi";

export const useSGMSlug = (): "sgm" | "sgp" =>
  useIsParlayLocale() ? "sgp" : "sgm";

export const useSRMSlug = (): "same-race-multi" | "same-race-parlay" =>
  useIsParlayLocale() ? "same-race-parlay" : "same-race-multi";

export const isSRMTab = (tab: string | undefined | null): boolean =>
  tab === "same-race-multi" || tab === "same-race-parlay";

export const isSGMTab = (tab: string | undefined | null): boolean =>
  tab === "sgm" || tab === "sgp";
